import React, { useEffect, useState } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton,
  Button, Text, Textarea, FormControl, FormLabel, useToast,
} from '@chakra-ui/react';
import { errorMessage } from 'api/administrador/monitoring/aiGrading';

/**
 * Confirmación de una acción del panel. Pide motivo (queda en Auditoría) y muestra el error del
 * API si la entrega cambió de estado mientras tanto.
 */
export default function ConfirmActionModal({
  isOpen, onClose, title, description, confirmLabel, danger = false, reasonLabel = 'Motivo (queda en Auditoría)',
  reasonRequired = false, withReason = true, onConfirm, onDone, successMessage, children, canConfirm = true,
}) {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (isOpen) setReason('');
  }, [isOpen]);

  const confirm = async () => {
    setBusy(true);
    try {
      const result = await onConfirm(reason.trim());
      toast({ status: 'success', title: typeof successMessage === 'function' ? successMessage(result) : successMessage, duration: 4000, isClosable: true });
      onClose();
      if (onDone) onDone(result);
    } catch (e) {
      toast({ status: 'error', title: errorMessage(e), duration: 6000, isClosable: true });
    } finally {
      setBusy(false);
    }
  };

  const disabled = !canConfirm || (withReason && reasonRequired && !reason.trim());

  return (
    <Modal isOpen={isOpen} onClose={busy ? () => {} : onClose} isCentered size="lg">
      <ModalOverlay />
      <ModalContent borderRadius="16px">
        <ModalHeader fontSize="20px" pb={1}>{title}</ModalHeader>
        <ModalCloseButton isDisabled={busy} />
        <ModalBody>
          {description && <Text fontSize="sm" color="gray.600" mb={4}>{description}</Text>}
          {children}
          {withReason && (
            <FormControl mt={children ? 4 : 0} isRequired={reasonRequired}>
              <FormLabel fontSize="13px" fontWeight="600">{reasonLabel}</FormLabel>
              <Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={2} maxLength={500} resize="none" />
            </FormControl>
          )}
        </ModalBody>
        <ModalFooter gap={2} borderTop="1px solid" borderColor="gray.100" mt={4}>
          <Button variant="outline" onClick={onClose} isDisabled={busy} borderRadius="10px">Cancelar</Button>
          <Button
            onClick={confirm}
            isLoading={busy}
            isDisabled={disabled}
            borderRadius="10px"
            bg={danger ? '#B91C1C' : '#574feb'}
            color="white"
            _hover={{ bg: danger ? '#991B1B' : '#4338CA' }}
          >
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
